import { render, staticRenderFns } from "./image-preview.vue?vue&type=template&id=2356703c&scoped=true&"
import script from "./image-preview.vue?vue&type=script&lang=js&"
export * from "./image-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2356703c",
  null
  
)

export default component.exports